const wrapper = "_086w1dmv6ph";
const logo = "_086l1wmondn";
const textWrapper = "_086t5alcy0";

export { logo, textWrapper, wrapper };
import "./print.header.style.linaria.module.css";
//# sourceMappingURL=print.header.style.js.map
